import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconIFrame = /*@__PURE__*/ proxyCustomElement(class WppIconIFrame extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-iframe", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M9.28033 9.53033C9.57322 9.23744 9.57322 8.76256 9.28033 8.46967C8.98744 8.17678 8.51256 8.17678 8.21967 8.46967L5.71967 10.9697C5.42678 11.2626 5.42678 11.7374 5.71967 12.0303L8.21967 14.5303C8.51256 14.8232 8.98744 14.8232 9.28033 14.5303C9.57322 14.2374 9.57322 13.7626 9.28033 13.4697L7.31066 11.5L9.28033 9.53033Z", fill: "currentColor" }), h("path", { d: "M11.7803 8.46967C11.4874 8.17678 11.0126 8.17678 10.7197 8.46967C10.4268 8.76256 10.4268 9.23744 10.7197 9.53033L12.6893 11.5L10.7197 13.4697C10.4268 13.7626 10.4268 14.2374 10.7197 14.5303C11.0126 14.8232 11.4874 14.8232 11.7803 14.5303L14.2803 12.0303C14.5732 11.7374 14.5732 11.2626 14.2803 10.9697L11.7803 8.46967Z", fill: "currentColor" }), h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 2H15C16.6569 2 18 3.34315 18 5V15C18 16.6569 16.6569 18 15 18H5C3.34315 18 2 16.6569 2 15V5C2 3.34315 3.34315 2 5 2ZM5 3.5C4.17157 3.5 3.5 4.17157 3.5 5V5.5H16.5V5C16.5 4.17157 15.8284 3.5 15 3.5H5ZM3.5 15V7H16.5V15C16.5 15.8284 15.8284 16.5 15 16.5H5C4.17157 16.5 3.5 15.8284 3.5 15Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-iframe-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-iframe", "wpp-icon-iframe-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-iframe-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-iframe-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconIFrame);
      }
      break;
  } });
}

const WppIconIframe = WppIconIFrame;
const defineCustomElement = defineCustomElement$1;

export { WppIconIframe, defineCustomElement };
